export function Blog() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.428833V18.4288H18V0.428833H0ZM15 15.4288H3V14.4288H15V15.4288ZM15 13.4288H3V12.4288H15V13.4288ZM15 9.42883H3V3.42883H15V9.42883Z"
        fill="currentColor"
      />
    </svg>
  );
}
